import { __assign, __rest } from "tslib";
// DS1.10.1
// DS1.10.2
// DS1.10.3
import { useReverseTheme } from '@wix/da-react-context/pkg/ThemeContext';
import React from 'react';
import { usePopoverOnInteraction } from '../../../popper/hooks/usePopoverOnInteraction';
import SophisticatedTooltipBase from '../../lego/SophisticatedTooltipBase';
/**
 * A more sophisticated tooltip than SimpleTooltip. This handles the expected UX for a standard tooltip.
 *
 * If `heading` isn't supplied, `aria-label` is required to fulfill a11y requirements.
 *
 * If you want an FTUE tooltip, consider using `SophisticatedFtueTooltip` instead.
 */
var SophisticatedTooltip = function (_a) {
    var forceVisible = _a.isVisible, rest = __rest(_a, ["isVisible"]);
    var isForcingVisibility = forceVisible !== undefined;
    var shouldListenForEvents = !isForcingVisibility;
    var _b = usePopoverOnInteraction({
        listenOnClicks: shouldListenForEvents,
        listenOnHover: shouldListenForEvents,
        hideOnScroll: shouldListenForEvents,
    }), isVisible = _b.isVisible, onClick = _b.onClick, onMouseEnter = _b.onMouseEnter, onMouseLeave = _b.onMouseLeave, onClose = _b.onClose;
    var reverseTheme = useReverseTheme();
    return isForcingVisibility ? (React.createElement(SophisticatedTooltipBase, __assign({ isVisible: forceVisible, forceTheme: reverseTheme }, rest))) : (React.createElement(SophisticatedTooltipBase, __assign({ isVisible: isVisible, forceTheme: reverseTheme, onReferenceClick: onClick, onReferenceMouseEnter: onMouseEnter, onReferenceMouseLeave: onMouseLeave, onClose: onClose }, rest)));
};
SophisticatedTooltip.displayName = 'SophisticatedTooltip';
export default SophisticatedTooltip;
//# sourceMappingURL=SophisticatedTooltip.js.map